import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import initialState from "../initial-state";
import { ErrorType } from "../../components/modals/Error";

const error = createSlice({
  name: "error",
  initialState: initialState.error,
  reducers: {
    setError(_, action: PayloadAction<ErrorType>) {
      const code = action.payload?.code ?? action.payload?.ErrorCode ?? -1;
      return { ...action.payload, code };
    },
    clearError() {
      return null;
    },
  },
});

export const { setError, clearError } = error.actions;

export default error;
